import { Calendar, Clock, User } from "lucide-react";
import { SiteBreadcrumb } from "@/components/SiteBreadcrumb";
import { FeaturedImage } from "@/components/blog/sf-pool-guide/Visuals";
import { TableOfContents } from "@/components/blog/sf-pool-guide/TableOfContents";
import { BodyPart1 } from "@/components/blog/sf-pool-guide/BodyPart1";
import { BodyPart2 } from "@/components/blog/sf-pool-guide/BodyPart2";
import { BodyPart3 } from "@/components/blog/sf-pool-guide/BodyPart3";

const ArticleSouthFloridaPoolRemodelingGuide = () => {
  return (
    <article className="flex flex-col min-h-screen bg-background text-foreground">
      {/* Article Header / Hero */}
      <header className="relative pt-40 pb-16 md:pt-44 md:pb-20 bg-[#0B1F3D] text-white">
        <SiteBreadcrumb />
        <div className="container relative z-10 mx-auto px-4 max-w-4xl">
          <div className="flex flex-wrap items-center gap-3 text-xs font-semibold uppercase tracking-wider text-[#00A3D9] mb-4">
            <span className="bg-[#00A3D9]/10 border border-[#00A3D9]/30 px-3 py-1 rounded-full">
              Pool Remodeling Guide
            </span>
            <span>•</span>
            <span className="flex items-center gap-1 text-white/70">
              <Calendar className="w-3.5 h-3.5 text-[#00A3D9]" />
              October 5, 2026
            </span>
            <span>•</span>
            <span className="flex items-center gap-1 text-white/70">
              <Clock className="w-3.5 h-3.5 text-[#00A3D9]" />
              Est. 10 min read
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-extrabold text-white leading-tight mb-6">
            South Florida Pool Remodeling Guide: Resurfacing, Tile, Coping,
            Decks, Costs, and Planning
          </h1>

          <div className="flex items-center gap-3 text-sm text-white/80 border-t border-white/15 pt-6">
            <div className="w-10 h-10 rounded-full bg-[#00A3D9]/20 border border-[#00A3D9]/40 flex items-center justify-center text-[#00A3D9]">
              <User className="w-5 h-5" />
            </div>
            <div>
              <div className="font-semibold text-white">
                Precision Pavers & Pool Design Team
              </div>
              <div className="text-xs text-white/60">
                South Florida Outdoor Living Specialists
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Body Container */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <FeaturedImage />
        <BodyPart1 toc={<TableOfContents />} />
        <BodyPart2 />
        <BodyPart3 />
      </div>
    </article>
  );
};

export default ArticleSouthFloridaPoolRemodelingGuide;
